import { Injectable } from '@angular/core';
import {
  AmountLimits,
  AmountOperation,
  UserCapabilities,
  getAmountLimits,
  parseUserCapabilities,
} from '../utils/wallet-profiling';

@Injectable({ providedIn: 'root' })
export class UserCapabilitiesService {
  private capabilities: UserCapabilities | null = null;

  setFromSignIn(payload: unknown): void {
    const record =
      payload && typeof payload === 'object'
        ? (payload as { capabilities?: unknown }).capabilities
        : undefined;
    this.capabilities = parseUserCapabilities(record);
  }

  clear(): void {
    this.capabilities = null;
  }

  amountLimits(operation: AmountOperation): AmountLimits {
    return getAmountLimits(this.capabilities, operation);
  }
}
